import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppCard, AppCardContent, AppCardHeader, AppCardTitle } from "../../Generic/AppCard";
import { AppList, AppListItem } from "../../Generic/AppList";
import PatientDetailsNoValue from "./PatientDetailsNoValue";

interface Props {
  priorityCode: number | null;
  mobilityStatus: string | null;
  evacuationLocation: string | null;
  evacuationZone: string | null;
  electricEquipmentDependency: string | null;
}

const EmergencyPreparednessCard = (props: Props) => {
  return (
    <AppCard className="EmergencyPreparednessCard">
      <AppCardHeader>
        <AppCardTitle>Emergency Preparedness</AppCardTitle>
      </AppCardHeader>
      <AppCardContent>
        <AppList>
          <AppListItem
            title={<b>{translate(STRINGS.PRIORITY_CODE)}</b>}
            trailing={props.priorityCode ?? <PatientDetailsNoValue />}
          />
          <AppListItem
            title={<b>{translate(STRINGS.MOBILITY_STATUS)}</b>}
            trailing={props.mobilityStatus ?? <PatientDetailsNoValue />}
          />
          <AppListItem
            title={<b>{translate(STRINGS.EVACUATION_LOCATION)}</b>}
            trailing={props.evacuationLocation ?? <PatientDetailsNoValue />}
          />
          <AppListItem
            title={<b>{translate(STRINGS.EVACUATION_ZONE)}</b>}
            trailing={props.evacuationZone ?? <PatientDetailsNoValue />}
          />
          <AppListItem
            title={<b>{translate(STRINGS.ELECTRIC_EQUIPMENT_DEPENDENCY)}</b>}
            trailing={props.electricEquipmentDependency ?? <PatientDetailsNoValue />}
          />
        </AppList>
      </AppCardContent>
    </AppCard>
  );
};

export default EmergencyPreparednessCard;
